import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import RPC from './mixins/RPC'
import VueTippy, { TippyComponent } from "vue-tippy";

Vue.use(VueTippy);
Vue.component("tippy", TippyComponent);
import "tippy.js/themes/light.css";
import "tippy.js/themes/light-border.css";
//import "tippy.js/themes/google.css";
import "tippy.js/themes/translucent.css";

/***************************************************************************/
//// Import Calendar
//import VCalendar from 'v-calendar';
//// Use v-calendar & v-date-picker components
//Vue.use(VCalendar, {
//    //  componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
//    //  ...,                // ...other defaults
//});

//import moment from 'moment';
var moment = require('moment');
var pako = require('pako');

Vue.mixin(RPC)
Vue.mixin({
    methods: {
	moment: moment,
	moment_utc: moment.utc,
	pako_inflate: pako.inflate,
    }
})

import VueJsonPretty from 'vue-json-pretty'
Vue.component('vue-json-pretty', VueJsonPretty)


import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
      key: 'AIzaSyDbAnSyU4fEIL3-a-LnHQwiFx-bTnIUzeI',
   // libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
})


Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: function (h) { return h(App) },
    beforeCreate: function() {
        store.dispatch('userWhoAmI')
    }
}).$mount('#app')
